<template>
  <v-toolbar app style="background: #fff" class="b2btopToolbarClass">
    <div class="royalties">
      <div
        style="margin-right: 12px"
        @click="openSidebar($event)"
        class="sidenav-button"
        v-if="!appDrawer"
      >
        <!-- <span style="width: 15px" class="material-icons">
          menu
        </span> -->
        <span>
          <img src="static/icons/menu-black.svg" />
        </span>
      </div>

      <div>
        <h4>{{ $t(activeRouteName) }}</h4>
        <h6 v-if="activeSubRouteItem">
          {{ activeSubRouteItem.route }}
        </h6>
      </div>
    </div>

    <div v-if="!isMobileScreen" class="nab-actions">
      <!-- <v-btn style="margin-right: auto" icon>
        <v-menu v-if="user" content-class="b2b-menu" offset-y>
          <button class="user-name" slot="activator">
            <span>{{ getInitial(user.given_name) }}</span>
          </button>
          <v-list class="filter-more-options-list">
            <v-list-tile
              class="options-item"
              v-for="(item, index) in dropdownItems"
              :key="index"
              @click="onMenuItemClicked(item)"
            >
              <v-icon>{{ item.icon }}</v-icon
              >&nbsp;
            
              <v-list-tile-title>{{ $t(item.title) }}</v-list-tile-title>
              
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-btn> -->
      <v-menu transition="slide-y-transition" content-class="b2b-menu" offset-y>
        <button class="user-name" slot="activator">
          <span>{{ getInitial(user.given_name) }}</span>
        </button>
        <div class="dropdown account-dropdown-menu">
          <div class="dropdown--list">
            <div
              class="dropdown--item"
              v-for="(item, index) in dropdownItems"
              :key="index"
              @click="onMenuItemClicked(item)"
            >
              <img
                v-if="item.icon == 'person'"
                style="width: 24px"
                src="static/icons/person.svg"
                alt="User Account"
                title="User Account"
              />
              <img
                v-if="item.icon == 'logout'"
                src="static/icons/logout.svg"
                alt="Logout"
                title="Logout"
              />&nbsp;
              <div style="padding: 4px 0px" class="dropdown--item--text">
                {{ $t(item.title) }}
              </div>
            </div>
          </div>
        </div>
      </v-menu>
    </div>
  </v-toolbar>
</template>

<script>
import Dropdown from "../../plugins/dropdown/dropdown";
import * as types from "../../modules/b2b/store/types.js";
import { B2BStoreNamespace as storeNS } from "../../modules/b2b/store/index";
import { mapGetters, mapActions } from "vuex";
import { isMobile } from "../../utility";
export default {
  name: "B2BHeaderComponent",
  components: {
    Dropdown,
  },
  props: {
    showtemporary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMobileScreen: false,
      topToolbarClass: {
        "top-toolbar": true,
      },
      dropdownItems: [
        {
          id: "1",
          title: "detailsb2b_edit_profile",
          icon: "person",
          route: "edit_user",
        },

        {
          id: "2",
          title: "detailsb2b_logout",
          icon: "logout",
          route: "logout",
        },
      ],
      activeRouteName: "",
    };
  },

  mounted: function () {
    if (isMobile()) {
      this.isMobileScreen = true;
    } else {
      this.isMobileScreen = false;
    }
  },
  computed: {
    ...mapGetters(storeNS, {
      activeRouteItem: "activeRouteItem",
      activeSubRouteItem: "activeSubRouteItem",
      appNavItems: "appNavItems",
      appDrawer: "appDrawer",
      user: "user",
    }),
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {
        this.activeRouteName = this.$route.name;
      },
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [types.B2B_LOGGED_OUT]: types.B2B_LOGGED_OUT,
    }),
    openSidebar: function (e) {
      e.stopPropagation();
      this.$emit("closeMainNav", true);
    },
    sideIconClicked: function (event) {
      this.$store.commit(`${storeNS}/${types.B2B_TOGGLE_SIDE_NAV}`, event);
    },
    logOut(item) {
      this[types.B2B_LOGGED_OUT]();
      this.$store.commit(`${storeNS}/${types.B2B_RESET_DATA}`, true);
    },
    onMenuItemClicked(item) {
      if (item.route === "logout") {
        this.logOut();
      } else {
        this.onEditUserClick(item);
      }
    },
    onEditUserClick: function (item) {
      console.log("this.$route", this.$route);
      this.$router.push({
        path: this.$route.fullPath,
        query: {
          modal: item.route,
        },
      });
    },
    getInitial(name) {
      if (!name) {
        return;
      }
      var initials = name.match(/\b\w/g) || [];
      initials = (
        (initials.shift() || "") + (initials.pop() || "")
      ).toUpperCase();
      return initials;
    },
  },
};
</script>

<style style lang="scss">
.b2btopToolbarClass {
  .toolbar__content {
    height: 100px !important;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .nab-actions {
      margin-left: auto;
      display: flex;
      align-items: center;
      margin-right: 0;
      max-height: 100px !important;
      button {
        border: none !important;
      }
      .sidenav-button {
        cursor: pointer;
      }
      .dropdown--list .dropdown--item {
        cursor: pointer;
        padding: 6px 15px;
        display: flex;
      }
    }
  }
  .top-toolbar {
    background: #fff;
  }
  .user-name {
    width: 42px;
    height: 42px;
    background-color: #4fe890;
    border-radius: 50%;
    border: 1px solid #fff;
    transition: all 0.2s ease-in-out;

    span {
      justify-content: center;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #424242;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
    }
  }
  .royalties {
    display: flex;
    margin-right: auto;
    margin-left: 25px !important;
    color: #505050;
    font-family: Roboto;
    font-size: 30px;
    font-weight: 500;
    line-height: 40px;
    cursor: pointer;
    .sidenav-button {
      border: none;
      border-radius: 0;
    }
  }

  .btn__content::before {
    opacity: 0;
  }
}

.b2btopToolbarClass.toolbar.toolbar--fixed .toolbar__content {
  background: #fff;
  border-bottom: hidden;
}

@media only screen and (max-width: 599px) {
  .toolbar__content {
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: wrap;
    .nab-actions {
      max-height: 120px !important;
    }
  }
  .royalties {
    flex-direction: column;
  }
}
</style>
